import React from "react";
import './container.styles.css'

// @ts-ignore

export interface containerProps {
    children?: Array<any> | any,
    reverse?: boolean,
    style?: any,
}

class GradientContainer extends React.Component<containerProps, {}> {
    render() {

        return <div style={this.props.style}
                    className={"container-gradient" + (this.props.reverse ? "-backwards" : "")}>
            <div className={"content-wrapper"}>
                {this.props.children}
            </div>
        </div>;
    }

}

export default GradientContainer;